export const TASKS_COLUMNS = {
	name: "name",
	deadline: "date_mks0n9xg",
	timeline: "timerange_mks08dne",
	user: "board_relation_mks0jxnw",
	userEmail: "text_mkwfst8e",
	type: "color_mks0p69y",
	who: "color_mks0vpn8",
	status: "status",
	visibility: "boolean_mkswbq97",
} as const;

export const PARENT_TASKS_COLUMNS = {
	name: "name",
	briefs: "board_relation_mkv75s5z",
	products: "board_relation_mkqzr4t9",
} as const;

export enum TASK_WHO {
	altavia = "#9d50dd",
}

export enum TASK_STATUS {
	notStarted = "Not started",
	running = "Running",
	waiting = "Waiting for customer",
	cancelled = "Cancelled",
	done = "Done",
	blocked = "Blocked",
	toCome = "To come",
}

export const TASK_STATUS_COLOR = {
	[TASK_STATUS.done]: "bg-[#33d391]",
	[TASK_STATUS.running]: "bg-[#b0dc51]",
	[TASK_STATUS.notStarted]: "bg-[#ffd533]",
	[TASK_STATUS.toCome]: "bg-[#339ecd]",
	[TASK_STATUS.waiting]: "bg-[#ff8358]",
	[TASK_STATUS.blocked]: "bg-[#e8697d]",
	[TASK_STATUS.cancelled]: "bg-[#5c5c5c]",
};
export const TASK_STATUS_TABLE = Object.keys(TASK_STATUS_COLOR);
